import type { MutationTree } from 'vuex'
import type { UserState } from './types'
import type { UserSetting } from '@/types/user'
import { USER_MUTATIONS } from './types'

interface IUserMutations extends MutationTree<UserState> {
  [USER_MUTATIONS.SET_SETTINGS](state: UserState, userSettings: UserSetting): void
  [USER_MUTATIONS.UPDATE_SETTINGS](state: UserState, userSettings: UserSetting): void
}

const mutations: IUserMutations = {
  [USER_MUTATIONS.SET_SETTINGS](state, userSettings) {
    if (userSettings.bluesky) {
      if (!userSettings.bluesky.lastViewedVersion) {
        userSettings.bluesky.lastViewedVersion = '1.0.0'
      }
      state.settings = userSettings.bluesky
      state.settings.viewedSubscriptionExpired ??= null
      state.settings.devicesUpdated ??= []
    }
  },
  [USER_MUTATIONS.UPDATE_SETTINGS](state, userSettings) {
    if (userSettings.bluesky) {
      state.settings = { ...state.settings, ...userSettings.bluesky }
    }
  }
}

export default mutations
